import React from "react";
import { XP_ICON_SRC } from "../../utils/xp";
/** Shared copy for About XP / rules surfaces. */
export function XpRulesContent() {
  return (
    <div className="space-y-4 font-chakra text-[12px] font-normal normal-case leading-[18px] tracking-normal text-white/85">
      <p className="leading-[18px]">
        <span className="inline-flex items-baseline gap-1 align-baseline">
          <img
            src={XP_ICON_SRC}
            alt=""
            className="h-[14px] w-[14px] shrink-0 object-contain"
            aria-hidden
          />
          <strong className="font-anton text-[13px] font-normal uppercase leading-[18px] text-white [leading-trim:none]">
            XP
          </strong>
        </span>{" "}
        <span className="inline leading-[18px]">
          lets you earn XP by playing our games, watching matches and interacting with your friends. Battle on
          the weekly leaderboard to earn bragging rights with your friends, and collect crown finishes on your
          profile.
        </span>
      </p>

      <section>
        <h3 className="mb-1.5 font-anton text-[13px] font-normal uppercase leading-[16px] text-white">
          How you earn XP
        </h3>
        <ul className="list-disc space-y-2 pl-5">
          <li>
            <strong className="text-white">Daily habits</strong> — log in, spin the Wheel, and keep streaks going.
          </li>
          <li>
            <strong className="text-white">Games</strong> — play Quickfire, Squares, Bullion, Sixes, and Trader.
          </li>
          <li>
            <strong className="text-white">Profile & friends</strong> — complete your profile, add friends, and invite
            new players.
          </li>
          <li>
            <strong className="text-white">Shop</strong> — unlock packs and get Rubies.
          </li>
        </ul>
        <p className="mt-2 text-[11px] text-white/55">
          Exact amounts appear in your XP history for each award.
        </p>
      </section>

      <section>
        <h3 className="mb-1.5 font-anton text-[13px] font-normal uppercase leading-[16px] text-white">
          Weekly leaderboard
        </h3>
        <ul className="list-disc space-y-2 pl-5">
          <li>
            Each week runs Monday 00:00 to Sunday 23:59 <strong className="text-white">IST</strong> (India time).
          </li>
          <li>
            <strong className="text-white">Week XP</strong> is the XP you earned during the current week only.
          </li>
          <li>
            Finish in the top three when the week ends to earn a gold, silver, or bronze crown on your avatar
            and a finish count on your profile under <em className="not-italic text-white/70">Weekly XP leaderboard finishes</em>.
            Tied ranks share the same crown (e.g. two players tied for 1st both wear gold the following week).
          </li>
          <li>Open the leaderboard from your profile or XP history to see rankings and time left in the week.</li>
        </ul>
      </section>

      <section>
        <h3 className="mb-1.5 font-anton text-[13px] font-normal uppercase leading-[16px] text-white">
          All-time XP
        </h3>
        <p>
          <strong className="text-white">All-time XP</strong> is your lifetime total and never resets. Use the Week /
          All time toggle on the leaderboard to compare weekly competition with career totals.
        </p>
      </section>
    </div>
  );
}
